import { render, staticRenderFns } from "./AkpkCardModal.vue?vue&type=template&id=5bb7acee"
import script from "./AkpkCardModal.vue?vue&type=script&lang=js"
export * from "./AkpkCardModal.vue?vue&type=script&lang=js"
import style0 from "./AkpkCardModal.vue?vue&type=style&index=0&id=5bb7acee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports